import React from 'react';
import Icon, { COLORS, ICONS } from '../../../general-components/icon';

interface OwnProps {
	isExpanded: boolean,
	elementCount: number,
	onExpandClick: (section: 'myBackgrounds' | 'defaultBackgrounds', elementCount: number) => void,
	section: 'myBackgrounds' | 'defaultBackgrounds'
}

export default function ExpandFooter(props: OwnProps) {
	const {
		isExpanded,
		elementCount,
		onExpandClick,
		section,
	} = props;

	// if you want to be able to open/close, remove the isExpanded check
	if (isExpanded || elementCount < 10) return <></>;
	return <div
		className='bl-font-header flex-center cursor-pointer text-gray-400'
		style={{ marginTop: isExpanded ? '24px' : '16px' }}
		onClick={() => onExpandClick(section, elementCount)}
	>
		<h6 className='margin-none margin-right-extra-small bl-font-header'>
			{`${isExpanded ? 'Close' : 'Show More'}`}
		</h6>
		<Icon
			size={12}
			color={COLORS.TEXT_GRAY_400}
			name={isExpanded ? ICONS.CARROT_UP : ICONS.CARROT_DOWN}
		/>
	</div>;
}
